import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "react-query";
import axios from "axios"; // Import axios

const useUpsertUser = () => {
  const { getAccessTokenSilently } = useAuth0();
  const apiUrl = process.env.REACT_APP_API_URL;

  const mutation = useMutation(async (userData) => {
    const token = await getAccessTokenSilently();

    return axios
      .post(`${apiUrl}/api/users`, userData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        // Handle errors more effectively with Axios
        throw new Error(
          error.response ? error.response.data.error : "An error occurred"
        );
      });
  });

  return mutation;
};

export default useUpsertUser;
